export class LocalStorageWorker {
  public localStorageSupported: boolean;
  public key: any;
  constructor() {
    this.localStorageSupported = this.canWriteStorage();

    this.key = {
      COOKIE: "cookie",
      UUID: "uuid",
      GX_USER_LIST: "gx_user_list",
      GX_MEDIA_LIST: "gx_media_list",
      IS_LIMITED_COIN_FIRST_SHOW: "is_limited_coin_first_show"
    };
  }

  public canWriteStorage() {
    if (!window.localStorage) {
      console.log("window下不存在localStorage");
      return false;
    }
    try {
      window.localStorage.setItem("@@", "test");
      window.localStorage.removeItem("@@");
      return true;
    } catch (e) {
      console.log("window不能使用localStorage");
      return false;
    }
  }

  public dataToString(data: any) {
    if (data !== undefined && data != null) {
      const type = typeof data;
      if (type === "function") {
        return undefined;
      } else if (type === "object") {
        return JSON.stringify(data);
      } else {
        return data.toString();
      }
    } else {
      return undefined;
    }
  }

  public stringToData(str: string) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return str;
    }
  }

  public set(key: string, data: any) {
    if (this.localStorageSupported) {
      const dataStr: string = this.dataToString(data);
      localStorage.setItem(key, dataStr);
      return this.get(key);
    } else {
      return null;
    }
  }

  public get(key: string) {
    if (this.localStorageSupported) {
      const data: any = localStorage.getItem(key);
      return this.stringToData(data);
    } else {
      return null;
    }
  }

  /**
   *  判断是否有对应key的本地存储
   * @param key
   */
  public has(key: string) {
    if (this.localStorageSupported) {
      const result = this.get(key);
      return result == null || result === undefined ? false : true;
    } else {
      return false;
    }
  }

  /**
   * 获取所有的Key,转成object返回
   */
  public getAll() {
    const result = {};
    // for (let i = 0; i < localStorage.length; i++) {
    //   result[localStorage.key(i)] = this.get(localStorage.key(i));
    // }
    return result;
  }

  public remove(key: string) {
    if (this.localStorageSupported) {
      localStorage.removeItem(key);
    } else {
      return null;
    }
  }

  public clear() {
    if (this.localStorageSupported) {
      localStorage.clear();
    } else {
      return null;
    }
  }
}
const localStorageHelper = new LocalStorageWorker();
export default localStorageHelper;
